import { HTMLEditor } from 'gadjet/dist/module/ui/html-editor/html-editor';


HTMLEditor.define('el-html-editor');